function App() {
  return (
    <div style={{textAlign: 'center', marginTop: '100px'}}>
      <h1>Мій сайт на Cloudflare 🚀</h1>
      <p>Розгорнуто через GitHub + Cloudflare Pages</p>
    </div>
  );
}

export default App;